import type { CarbonIntensityDataPoint } from '../../services/carbonIntensityService';

export function buildCarbonSourceStatusSentence(
  seriesByYear: CarbonIntensityDataPoint[] | undefined,
  latestYear: number
): string {
  const point = seriesByYear?.find((p) => p.year === latestYear);
  if (!point) return '';
  switch (point.source) {
    case 'cca':
      return ` The ${latestYear} value comes from the matched Power Content Label.`;
    case 'observed':
      return ` The ${latestYear} value comes from the matched eGRID utility factor.`;
    case 'interpolated':
      return ` The ${latestYear} value is interpolated between observed source years.`;
    case 'extrapolated':
      return ` The ${latestYear} value is extrapolated from the observed series.`;
    default:
      return '';
  }
}
